import { BordOneToneIcon } from 'components/NudosComponents';
import { BordTooltip } from 'bord-design-system';

import './QuoteToQuoteCountSummary.scss';

interface IQuoteToQuoteCountSummary {
  /** Herramientas aún pendientes por cotizar (ícono de reloj). */
  pendingToQuote?: number;
  /** Herramientas ya cotizadas (ícono de check). */
  quoted?: number;
}

/**
 * Resumen con dos contadores para la pestaña "Por cotizar": el primero
 * (reloj) son las herramientas pendientes por cotizar y el segundo (check)
 * las ya cotizadas. Replica el estilo de QuoteProductStatusCountSummary.
 */
export const QuoteToQuoteCountSummary = ({ pendingToQuote = 0, quoted = 0 }: IQuoteToQuoteCountSummary) => {
  return (
    <div className="quoteToQuoteCountSummary">
      <BordTooltip
        customClassNameMessageContainer="toolsStatusTooltip"
        message="Herramientas pendientes por cotizar"
        position="top"
      >
        <div className="item">
          <BordOneToneIcon className="quoteToQuoteCountSummaryIcon" variant="clock" customWidth="1.2rem" />
          {pendingToQuote}
        </div>
      </BordTooltip>
      <div className="divider" />
      <BordTooltip customClassNameMessageContainer="toolsStatusTooltip" message="Herramientas cotizadas" position="top">
        <div className="item">
          <BordOneToneIcon className="quoteToQuoteCountSummaryIcon" variant="checkCircle" customWidth="1.2rem" />
          {quoted}
        </div>
      </BordTooltip>
    </div>
  );
};
